// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_dyh9h {
  height : 100%;
  width: 100%;
  min-height: 380px;
  min-width: 400px;
  background-color : var( --color-base050 );
}

.pairItem_Q3kGU {
  padding : var( --size-padMedium ) 0 0 0;
}

.pairItem_Q3kGU > label {
  padding : 0 0 var( --size-padSmall ) 0;
  display : block
}

.pairItem_Q3kGU > input[type='text'] {
}

.submit_stTI3 {
  align-self : flex-end;
}

.divider_CsbkK {
  width : 100%;
  border-bottom : 1px solid var(--color-base025)
}

.successLink_WJ8a8 {
  width : 100%;
  margin : 8px 0;
}


.pairButtons_fMnxL {
  /* display: flex;
  justify-content: flex-end; */
}

.pairImage_rrlty {
  width : 30%;
}

.dataBlock_Y59rf {
  width : 80%;
}

@media only screen and (max-width: 1024px) {
  .pairImage_rrlty {
    width : 70%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-pairing/lib/bulkPairing/views/bulk/Pair.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC;AACF;;AAEA;AACA;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;;AAGA;EACE;8BAC4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".content {\n  height : 100%;\n  width: 100%;\n  min-height: 380px;\n  min-width: 400px;\n  background-color : var( --color-base050 );\n}\n\n.pairItem {\n  padding : var( --size-padMedium ) 0 0 0;\n}\n\n.pairItem > label {\n  padding : 0 0 var( --size-padSmall ) 0;\n  display : block\n}\n\n.pairItem > input[type='text'] {\n}\n\n.submit {\n  align-self : flex-end;\n}\n\n.divider {\n  width : 100%;\n  border-bottom : 1px solid var(--color-base025)\n}\n\n.successLink {\n  width : 100%;\n  margin : 8px 0;\n}\n\n\n.pairButtons {\n  /* display: flex;\n  justify-content: flex-end; */\n}\n\n.pairImage {\n  width : 30%;\n}\n\n.dataBlock {\n  width : 80%;\n}\n\n@media only screen and (max-width: 1024px) {\n  .pairImage {\n    width : 70%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_dyh9h`,
	"pairItem": `pairItem_Q3kGU`,
	"submit": `submit_stTI3`,
	"divider": `divider_CsbkK`,
	"successLink": `successLink_WJ8a8`,
	"pairButtons": `pairButtons_fMnxL`,
	"pairImage": `pairImage_rrlty`,
	"dataBlock": `dataBlock_Y59rf`
};
export default ___CSS_LOADER_EXPORT___;
